import React from "react";
import "./App.css";
import "./tailwind.output.css";
import DrumMachine from "./components/DrumMachine";

function App() {
  return (
    <div className="App">
      <DrumMachine />
    </div>
  );
}

export default App;
